export const initialUrl = '/health/patient';

export const X_TOTAL_COUNT = 'x-total-count';

export const QUERY_SIZE_LIMIT = 1000;

export const VITAL_QUERY_SIZE_LIMIT = 100;

export const UPLOAD_MAX_FILE_SIZE = 10240000; //10MB

export const DEFAULT_AVATAR_URL = '/assets/images/placeholder.jpg';

export const SYSTEM_AVATAR_URL = '/assets/images/logo.png';

export const AuthSubject = {
  User: 'User',
  Role: 'Role',
  Subject: 'Subject',
};

export const AuthAction = {
  manage: 'manage',
  view: 'view',
  create: 'create',
  edit: 'edit',
  delete: 'delete',
};

export const ReferenceType = {
  SERVICE_REQUEST: 'SERVICE_REQUEST',
  ORDER: 'ORDER',
  TREATMENT: 'TREATMENT',
};

export const VitalType = {
  BLOOD_PRESSURE: 'BLOOD_PRESSURE',
  RESP_RATE: 'RESP_RATE',
  HEART_RATE: 'HEART_RATE',
  OXYGEN_SAT: 'OXYGEN_SAT',
  BODY_TEMP: 'BODY_TEMP',
  BODY_WEIGHT: 'BODY_WEIGHT',
  BODY_HEIGHT: 'BODY_HEIGHT',
};

export const ServiceRequestStatus = {
  draft: 'DRAFT',
  active: 'ACTIVE',
  completed: 'COMPLETED',
  cancel: 'CANCEL',
};

export const MediaType = {
  IMAGE: 'IMAGE',
  AUDIO: 'AUDIO',
  VIDEO: 'VIDEO',
  DOCUMENT: 'DOCUMENT',
  DICOM: 'DICOM',
};
